import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {},
});

export default theme;
